import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { H2 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { MeasurementCarousel } from './components/MeasurementCarousel/MeasurementCarousel.js';
import { MeasurementList } from './components/MeasurementList/MeasurementList.js';

const FrameMeasurements = ({ measurements  })=>{
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { getLabel  } = useIntl();
    const title = getLabel('products.measurements.frame.title');
    return /*#__PURE__*/ React.createElement("section", {
        className: "product-detail-frame-measurements",
        "aria-label": title
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-frame-measurements__container"
    }, /*#__PURE__*/ React.createElement(H2, {
        variant: "heading-large",
        className: "product-detail-frame-measurements__title"
    }, title), isMobile ? /*#__PURE__*/ React.createElement(MeasurementCarousel, {
        measurements: measurements
    }) : /*#__PURE__*/ React.createElement(MeasurementList, {
        measurements: measurements
    })));
};

export { FrameMeasurements };
//# sourceMappingURL=FrameMeasurements.js.map
